export const toMinorUnit = (
  value: string | number,
): number | undefined => {
  const normalized =
    typeof value === 'number'
      ? value
      : value.trim().replace(/\./g, '').replace(',', '.');

  const price = Number(normalized);

  if (!Number.isFinite(price) || price < 0) return undefined;

  return Math.round(price * 100);
};

export const waitForOpenAIPixel = (
  timeout = 3000,
): Promise<boolean> => {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') {
      resolve(false);
      return;
    }

    const startedAt = Date.now();

    const check = () => {
      if (typeof window.oaiq === 'function') {
        resolve(true);
        return;
      }

      if (Date.now() - startedAt >= timeout) {
        resolve(false);
        return;
      }

      window.setTimeout(check, 50);
    };

    check();
  });
};
